import AuthBody from './AuthBody';

export default AuthBody;
